import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

function Card({ className, ...props }: CardProps) {
  return (
    <div
      className={cn('rounded-lg border border-linen bg-white shadow-card', className)}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: CardProps) {
  return <div className={cn('p-6 pb-4', className)} {...props} />;
}

function CardTitle({ className, ...props }: CardProps) {
  return (
    <h3 className={cn('font-display text-display-sm text-forge', className)} {...props} />
  );
}

function CardContent({ className, ...props }: CardProps) {
  return <div className={cn('px-6 pb-6', className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardContent };
